// Central react-query keys so views and mutations invalidate consistently.
export const qk = {
  workspaces: ['workspaces'] as const,
  workspace: (ws: string | null) => ['workspace', ws] as const,
  apiKeys: (ws: string | null) => ['api-keys', ws] as const,
  marketplace: (ws: string | null) => ['marketplace', ws] as const,
  connections: (ws: string | null) => ['connections', ws] as const,
  connectedAccounts: (ws: string | null) => ['connected-accounts', ws] as const,
  activity: (ws: string | null, since: string) => ['activity', ws, since] as const,
  activityProbe: (ws: string | null) => ['activity-probe', ws] as const,
  triggers: (ws: string | null) => ['triggers', ws] as const,
  toolSearch: (ws: string | null, q: string, category: string) => ['tool-search', ws, q, category] as const,
  toolSchema: (ws: string | null, name: string) => ['tool-schema', ws, name] as const,
  toolSessions: (ws: string | null) => ['tool-sessions', ws] as const,
  // Public, workspace-independent.
  toolCategories: ['tool-categories'] as const,
  mcpDirectory: ['mcp-directory'] as const,
}
